import { api } from '../middleware/api';

// Define endpoints using injectApi pattern
export const poecancelorderApi = api
  .enhanceEndpoints({ addTagTypes: ['POECancelOrder'] })
  .injectEndpoints({
    endpoints: builder => ({
      getPOECancelOrders: builder.query<any[], string>({
        query: cid => `poecancelorder/${cid}`,
        providesTags: ['POECancelOrder']
      }),
      getPOECancelOrderById: builder.query<any, string>({
        query: id => `poecancelorder/byid/${id}`,
        providesTags: ['POECancelOrder']
      }),
      insertPOECancelOrder: builder.mutation({
        query: poecancelorder => ({
          url: `poecancelorder/`,
          method: 'POST',
          body: poecancelorder
        }),
        invalidatesTags: ['POECancelOrder']
      }),
      updatePOECancelOrder: builder.mutation({
        query: poecancelorder => ({
          url: `poecancelorder/`,
          method: 'PUT',
          body: poecancelorder
        }),
        invalidatesTags: ['POECancelOrder']
      }),
      deletePOECancelOrder: builder.mutation({
        query: poecancelorder => ({
          url: `poecancelorder/${poecancelorder.co_id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['POECancelOrder']
      })
    }),
    overrideExisting: false
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetPOECancelOrdersQuery,
  useGetPOECancelOrderByIdQuery,
  useInsertPOECancelOrderMutation,
  useUpdatePOECancelOrderMutation,
  useDeletePOECancelOrderMutation
} = poecancelorderApi;

